import { browserCheck } from '@ta-interaktiv/browsercheck'

const maxDays = 180

export const isMobile: boolean = browserCheck.isMobile

export const colCount = isMobile ? 2 : 3
export const graphColSpace = isMobile ? 10 : 15
export const graphXStart = isMobile ? 1 : 1

export const cantonsToHide = ['AI', 'CH']
export const cantonsNoIPS = ['AI', 'OW']
export const xScaleSteps = 60

export const vertTickTextOffset = { x: 5, y: 14 }
export const currentValueOffset = 16
export const newCHInfectionsSetup = {
  yRange: [100, 0],
  yDomain: [100000, 1],
  xDomain: [0, maxDays],
  yTicks: {
    lines: [1, 100, 10000, 100000],
    text: [100, 10000, 100000]
  }
}
const maxYRange = 600
export const hospitalizedSetup: {
  yRange: [number, number]
  yDomain: [number, number]
  xDomain: [number, number]
  yTicks: {
    lines: number[]
    text: number[]
  }
  xTicks: {
    lines: number[]
    text: number[]
  }
} = {
  yRange: [50, 0],
  yDomain: [maxYRange, 1],
  xDomain: [0, maxDays],
  yTicks: {
    lines: [0, maxYRange],
    text: [maxYRange]
  },
  xTicks: {
    lines: [0, 60, 120, 180],
    text: [0, 60, 120, 180]
  }
}
const maxYRangeIntense = 100

export const intensiveSetup: {
  yRange: [number, number]
  yDomain: [number, number]
  xDomain: [number, number]
  yTicks: {
    lines: number[]
    text: number[]
  }
  xTicks: {
    lines: number[]
    text: number[]
  }
} = {
  yRange: [50, 0],
  yDomain: [maxYRangeIntense, 1],
  xDomain: [0, maxDays],
  yTicks: {
    lines: [0, maxYRangeIntense],
    text: [maxYRangeIntense]
  },
  xTicks: {
    lines: [0, 60, 120, 180],
    text: [0, 60, 120, 180]
  },
  lastValueOffset: { x: 10, y: -10 }
}
const maxYRangeSwissHospital = 3000

export const swissHospitalSetup = {
  yRange: [250, 0],
  yDomain: [maxYRangeSwissHospital, 1],
  xDomain: [0, maxDays],
  yTicks: {
    lines: [0, 1000, 2000, maxYRangeSwissHospital],
    text: [1000, 2000, maxYRangeSwissHospital]
  },
  lastValueOffset: { x: 10, y: -10 }
}
export const markerRad = 1.5
export const showFirstValue = false
export const lastValueOffset = { x: 10, y: -10 }
